import { Component, HostListener } from '@angular/core';
import { AuthService } from 'app/core/http/services/auth.service';
import { environment } from 'app/environments/environment';
import { ActivatedRoute, Router,  Event, NavigationStart, NavigationEnd, NavigationError } from '@angular/router';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent {
  public title = environment.titleSite;
  public data;
  public showBackTop = false;
  public showSchedule = true;

  @HostListener('window:scroll') onScroll(e: Event): void {
    const position = Math.abs(document.body.getBoundingClientRect().top);
    if (position > 100) {
      this.showBackTop = true;
    } else {
      this.showBackTop = false;
    }
  }

  constructor(
    private readonly auth: AuthService,
    private readonly router: Router
  ) {
    var d = new Date();
    this.data = d.getFullYear();
    router.events.subscribe((event: Event) => {
      if (event instanceof NavigationEnd ) {
          this.showSchedule = !event.url.includes('calendario');        
      }
    });
  }

  public get isLoggedIn(): boolean {
    return this.auth.isAuthenticated();
  }

  onActivate(event: any) {
    this.backToTop();
  }

  backToTop() {
    window.scroll({
      top: 0,
      left: 0,
      behavior: 'smooth',
    });
  }
}
